import React, { useState, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useHistory } from 'react-router-dom';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import ArrowForward from '@mui/icons-material/ArrowForward';
import ActivateIcon from '@mui/icons-material/CheckCircle';
import MedicalServicesIcon from '@mui/icons-material/MedicalServices';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { fetchData, deleteData, activateData, postData, updateData, masterdataindex } from '../../../apiService';
import { Link } from 'react-router-dom';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import Button from '@mui/material/Button';
import Select from 'react-select';
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import AddIcon from '@mui/icons-material/Add';
import FitbitIcon from '@mui/icons-material/Fitbit';
import GamepadIcon from '@mui/icons-material/Gamepad';
import CopyrightIcon from '@mui/icons-material/Copyright';

function AppointmentIndex() {
    const [data, setData] = useState([]);
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const history = useHistory();
    const { isAuthenticated, companyId, permissions, userId, token, logout } = useAuth();
    const hasCreateMasterPermission = permissions.includes('Create Master');
    const hasEditMasterPermission = permissions.includes('Edit Master');
    const hasDeleteMasterPermission = permissions.includes('Delete Master');
    const [loading, setLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdateLoading, setIsUpdateLoading] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [errorMessageEdit, setErrorMessageEdit] = useState("");

    // FOR Create new customer
    const [Name, setName] = useState('');
    const [AddressLine1, setAddressLine1] = useState('');
    const [AddressLine2, setAddressLine2] = useState('');
    const [ContactNumber1, setContactNumber1] = useState('');
    const [ContactNumber2, setContactNumber2] = useState('');
    const [Email, setEmail] = useState('');

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }
        fetchtableData();
        setLoading(true);
    }, [isAuthenticated, companyId, userId, token, logout]);

    const [searchQuery, setSearchQuery] = useState('');
    const [showSearchInput, setShowSearchInput] = useState(false);

    const handleSearch = (event) => {
        setSearchQuery(event.target.value);
    };

    const toggleSearchInput = () => {
        setShowSearchInput(!showSearchInput);
    };

    const filteredData = data.filter((item) =>
        Object.values(item).some((value) =>
            String(value).toLowerCase().includes(searchQuery.toLowerCase())
        )
    );

    const [isFocused, setIsFocused] = useState(false);

    const fetchtableData = async () => {
        setLoading(true);
        fetchData('AppointmentApi', `/${companyId}`, token)
            .then((response) => {
                if (response.responseCode === '1111') {
                    setData(response.response_data);
                }
                console.log(response);
            })
            .catch((error) => {
                console.error('Error fetching Appointment Details:', error);
                if (error.response && error.response.status === 401) {
                    logout();
                    history.replace(`/login?redirect=${encodeURIComponent(window.location.pathname)}`);
                }
            })
            .finally(() => {
                setLoading(false);
            });
    };

    const handleDelete = async () => {
        deleteData('AppointmentApi', `${deleteItemId}`, token)
            .then((response) => {
                setDeleteItemId(null);
                setConfirmDialogOpen(false);
                window.location.reload();
            })
            .catch((error) => {
                console.error('Error deleting record:', error);
            });
    };

    const handleActivate = (itemId) => {
        activateData('AppointmentApi', `${itemId}`)
            .then(() => {
                // Fetch table data or update state
            })
            .catch((error) => {
                console.error('Error activating record:', error);
            });
    };

    const openConfirmDialog = (itemId) => {
        setDeleteItemId(itemId);
        setConfirmDialogOpen(true);
    };

    const closeConfirmDialog = () => {
        setDeleteItemId(null);
        setConfirmDialogOpen(false);
    };

    // Appointment Creation Modal
    const [isModalGrpOpen, setIsModalGrpOpen] = useState(false);
    const [patients, setPatients] = useState([]);
    const [doctors, setDoctors] = useState([]);
    const [isPatientModalOpen, setIsPatientModalOpen] = useState(false);
    const [patientSearchQuery, setPatientSearchQuery] = useState('');
    const [appointmentForm, setAppointmentForm] = useState({
        patientId: '',
        patientName: '',
        patientMRD: '',
        patientPhone: '',
        doctorId: '',
        appointmentDate: getCurrentDate(),
        appointmentTime: getCurrentTime(),
        consultationamount: ''
    });

    // Appointment List Modal States
    const [isAppointmentListModalOpen, setIsAppointmentListModalOpen] = useState(false);
    const [appointmentsList, setAppointmentsList] = useState([]);
    const [appointmentDateFilter, setAppointmentDateFilter] = useState('');
    const [appointmentDoctorFilter, setAppointmentDoctorFilter] = useState('');
    const [isLoadingAppointments, setIsLoadingAppointments] = useState(false);

    function getCurrentDate() {
        const today = new Date();
        return `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
    }

    function getCurrentTime() {
        const now = new Date();
        return `${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;
    }

    // Format date to dd/mm/yyyy
    const formatDate = (dateString) => {
        if (!dateString) return 'N/A';
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}/${month}/${year}`;
    };

    // Filter appointments based on date and doctor
    const getFilteredAppointments = () => {
        return appointmentsList.filter(apt => {
            let dateMatch = true;
            if (appointmentDateFilter && apt.AppointmentDate) {
                const aptDate = new Date(apt.AppointmentDate);
                const filterDate = new Date(appointmentDateFilter);
                dateMatch = aptDate.toDateString() === filterDate.toDateString();
            }
            const doctorMatch = !appointmentDoctorFilter || apt.DoctorName === appointmentDoctorFilter;
            return dateMatch && doctorMatch;
        });
    };

    // Toggle Appointment List Modal
    const toggleAppointmentListModal = async () => {
        if (!isAppointmentListModalOpen) {
            setIsLoadingAppointments(true);
            setIsAppointmentListModalOpen(true);
            try {
                const response = await fetchData('AppointmentApi', `/${companyId}`, token);
                if (response.responseCode === '1111') {
                    const sortedAppointments = response.response_data.sort((a, b) => {
                        const dateCompare = new Date(b.AppointmentDate) - new Date(a.AppointmentDate);
                        if (dateCompare !== 0) return dateCompare;
                        return (a.DoctorName || '').localeCompare(b.DoctorName || '');
                    });
                    setAppointmentsList(sortedAppointments);
                } else {
                    setAppointmentsList([]);
                }
            } catch (error) {
                console.error('Error fetching appointments:', error);
                setAppointmentsList([]);
            } finally {
                setIsLoadingAppointments(false);
            }
        } else {
            setIsAppointmentListModalOpen(false);
            setAppointmentDateFilter('');
            setAppointmentDoctorFilter('');
        }
    };

    const toggleModalGroup = () => {
        if (!isModalGrpOpen) {
            fetchPatientsForAppointment();
            fetchDoctorsForAppointment();
            setAppointmentForm({
                patientId: '',
                patientName: '',
                patientMRD: '',
                patientPhone: '',
                doctorId: '',
                appointmentDate: getCurrentDate(),
                appointmentTime: getCurrentTime(),
                consultationamount: ''
            });
        }
        setIsModalGrpOpen(!isModalGrpOpen);
    };

    const fetchPatientsForAppointment = async () => {
        try {
            const response = await fetchData('PatientApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                setPatients(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching patients:', error);
        }
    };

    const fetchDoctorsForAppointment = async () => {
        try {
            const response = await fetchData('DoctorApi', `/${companyId}`, token);
            if (response.responseCode === '1111') {
                setDoctors(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching doctors:', error);
        }
    };

    const handlePatientSelect = (patient) => {
        setAppointmentForm(prev => ({
            ...prev,
            patientId: patient.Id,
            patientName: patient.Name,
            patientMRD: patient.MRDNo,
            patientPhone: patient.ContactNumber1
        }));
        setIsPatientModalOpen(false);
    };

    const handleAppointmentChange = (field, value) => {
        if (field === 'doctorId') {
            const selectedDoctor = doctors.find(d => d.Id === parseInt(value) || d.Id === value);
            setAppointmentForm(prev => ({
                ...prev,
                doctorId: value,
                consultationamount: selectedDoctor?.ConsultationAmount || selectedDoctor?.Amount || ''
            }));
        } else {
            setAppointmentForm(prev => ({
                ...prev,
                [field]: value
            }));
        }
    };

    const handleAppointmentSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const payload = {
                CompanyId: companyId,
                PatientId: appointmentForm.patientId,
                DoctorId: appointmentForm.doctorId,
                AppointmentDate: appointmentForm.appointmentDate,
                AppointmentTime: appointmentForm.appointmentTime,
                Amount: Number(appointmentForm.consultationamount),
                CreatedBy: userId,
                CreatedDate: new Date()
            };

            const response = await postData('AppointmentApi', payload, token);
            if (response.responseCode === '1111') {
                alert('Appointment created successfully!');
                setIsModalGrpOpen(false);
                fetchtableData();
            }
        } catch (error) {
            console.error('Error creating appointment:', error);
            alert('Failed to create appointment');
        } finally {
            setIsLoading(false);
        }
    };

    const filteredPatients = patients.filter(patient =>
        patient.Name?.toLowerCase().includes(patientSearchQuery.toLowerCase()) ||
        patient.MRDNo?.toLowerCase().includes(patientSearchQuery.toLowerCase()) ||
        patient.ContactNumber1?.includes(patientSearchQuery)
    );


    return (
        <div className="container mt-2 mx-auto" style={{ maxWidth: '97%' }}>
            <div className='mb-2 flex justify-between' style={{ marginTop: '-20px' }}>
                <h6 className='productHead flex-grow linkcolor' style={{ fontFamily: 'Georgia, Cambria, "Times New Roman", Times, serif', color: 'black', textTransform: 'uppercase' }}>Appointment</h6>
                {loading && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        backdropFilter: 'blur(4px)',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 9999
                    }}>
                        <style>{`
                            .loader {
                                transform: rotateZ(45deg);
                                perspective: 1000px;
                                border-radius: 50%;
                                width: 48px;
                                height: 48px;
                                color: #fff;
                            }
                            .loader:before,
                            .loader:after {
                                content: '';
                                display: block;
                                position: absolute;
                                top: 0;
                                left: 0;
                                width: inherit;
                                height: inherit;
                                border-radius: 50%;
                                transform: rotateX(70deg);
                                animation: 1s spin linear infinite;
                            }
                            .loader:after {
                                color: #FF3D00;
                                transform: rotateY(70deg);
                                animation-delay: .4s;
                            }
                            @keyframes spin {
                                0%, 100% { box-shadow: .2em 0px 0 0px currentcolor; }
                                12% { box-shadow: .2em .2em 0 0 currentcolor; }
                                25% { box-shadow: 0 .2em 0 0px currentcolor; }
                                37% { box-shadow: -.2em .2em 0 0 currentcolor; }
                                50% { box-shadow: -.2em 0 0 0 currentcolor; }
                                62% { box-shadow: -.2em -.2em 0 0 currentcolor; }
                                75% { box-shadow: 0px -.2em 0 0 currentcolor; }
                                87% { box-shadow: .2em -.2em 0 0 currentcolor; }
                            }
                        `}</style>
                        <div className="loader"></div>
                        <span style={{ color: 'white', marginTop: '30px', fontSize: '16px', fontWeight: '500', letterSpacing: '0.5px' }}>
                            Loading...
                        </span>
                    </div>
                )}

                <div style={{ marginLeft: '-30px', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                    <input
                        className="shadow text-gray-700 leading-tight"
                        type="text"
                        placeholder="Search..."
                        value={searchQuery}
                        onChange={handleSearch}
                        onFocus={() => setIsFocused(true)}
                        onBlur={() => setIsFocused(false)}
                        style={{
                            width: isFocused ? '270px' : '200px',
                            height: '30px',
                            border: '1px solid #ccc',
                            borderRadius: '15px',
                            padding: '0 20px',
                            transition: 'width 0.4s ease-in-out, border-color 0.3s ease-in-out',
                            outline: 'none',
                            borderColor: isFocused ? 'darkcyan' : '#ccc',
                            boxShadow: isFocused ? '0 4px 8px rgba(0, 0, 0, 0.2)' : 'none',
                        }}
                    />
                </div>

                <Tooltip
                    title="View All Appointments" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: '#059669',
                                color: 'white',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ background: 'linear-gradient(135deg, #059669 0%, #047857 100%)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '11px', textTransform: 'uppercase', marginTop: '-2px', borderRadius: '25px' }}
                        onClick={toggleAppointmentListModal}
                        className="linkcolor"
                    >
                        📋 All Appointments
                    </Button>
                </Tooltip>

                <Tooltip
                    title="Create New Appointment" arrow
                    componentsProps={{
                        tooltip: {
                            sx: {
                                backgroundColor: 'White',
                                color: 'black',
                                border: '1px solid white',
                                fontWeight: 'bold',
                                boxShadow: 2,
                            },
                        },
                    }}
                >
                    <Button
                        style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)', marginLeft: '8px', color: 'white', fontWeight: 'bolder', height: '30px', fontSize: '11px', textTransform: 'uppercase', marginTop: '-2px', borderRadius: '25px' }}
                        onClick={toggleModalGroup}
                        className="linkcolor"
                    >
                        New Appointment
                    </Button>
                </Tooltip>
            </div>

            <div className='w-full mb-2 flex' style={{ maxHeight: '520px', overflowY: 'auto', width: '100%', marginTop: '-10px' }}>
                <TableContainer component={Paper}>
                    <Table stickyHeader>
                        <TableHead sx={{ backgroundColor: '#134B70', padding: '2px' }}>
                            <TableRow>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                    Sl.No
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                    MRD No
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                    Name & Contact
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                    Charted By
                                </TableCell>
                                <TableCell style={{
                                    background: "linear-gradient(180deg, #1e3a8a 0%, #1e40af 100%)", color: 'white',
                                    fontWeight: '600', fontSize: '11px', border: '1px solid #ccc', textAlign: 'left', position: 'sticky',
                                    top: 0, zIndex: 10, whiteSpace: 'nowrap', padding: '2px', borderRadius: '4px', textTransform: 'uppercase',
                                    borderBottom: '2px solid #1e40af',
                                }}>
                                </TableCell>
                            </TableRow>
                        </TableHead>

                        <TableBody>
                            {filteredData && filteredData.map((item, index) => (
                                <TableRow
                                    key={item.id}
                                    sx={{
                                        '&:hover': { backgroundColor: '#F1E7E7' },
                                        transition: 'background-color 0.3s ease-in-out',
                                        cursor: 'pointer',
                                    }}
                                >
                                    <TableCell sx={{ padding: '2px', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{index + 1}</TableCell>
                                    <TableCell sx={{ padding: '2px', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.MRDNo}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px', width: '30%' }}>{item.PatientName} / {item.ContactNumber1}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'left', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>{item.DoctorName}</TableCell>
                                    <TableCell sx={{ padding: '2px', textAlign: 'right', borderRight: '1px solid #f4dfdfff', fontSize: '11.5px' }}>
                                        <Tooltip
                                            title="Doctor Entry" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#10b981',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={() => history.push(`/DoctorEntryCreateIds/${item.Id}`)}>
                                                <MedicalServicesIcon style={{ color: '#10b981', fontSize: '17px' }} />
                                            </IconButton>
                                        </Tooltip>

                                        <Tooltip
                                            title="Appointment Delete" arrow
                                            componentsProps={{
                                                tooltip: {
                                                    sx: {
                                                        backgroundColor: '#DA6C6C',
                                                        color: 'white',
                                                        border: '1px solid white',
                                                        fontWeight: 'bold',
                                                        boxShadow: 2,
                                                    },
                                                },
                                            }}
                                        >
                                            <IconButton onClick={() => (item.IsActive ? openConfirmDialog(item.Id) : handleActivate(item.Id))}>
                                                {item.IsActive ? <DeleteIcon style={{ color: 'brown', fontSize: '17px' }} /> : <ActivateIcon />}
                                            </IconButton>
                                        </Tooltip>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>


            {/* Delete Confirmation Dialog */}
            <Dialog
                open={confirmDialogOpen}
                onClose={closeConfirmDialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{"Delete Record?"}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        Are you sure you want to delete this record?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <button onClick={closeConfirmDialog} className="bg-red-600 text-white border border-red-600 rounded px-4 py-2 mr-2">
                        Cancel
                    </button>
                    <button onClick={handleDelete} className="bg-green-600 text-white border border-green-600 rounded px-4 py-2">
                        Confirm
                    </button>
                </DialogActions>
            </Dialog>

            {/* Footer */}
            <div style={{
                position: 'fixed',
                bottom: '12px',
                right: '12px',
                display: 'flex',
                alignItems: 'center',
                gap: '0.3rem',
                padding: '0.3rem 0.65rem',
                background: 'rgba(255, 255, 255, 0.9)',
                borderRadius: '14px',
                boxShadow: '0 1px 6px rgba(0, 0, 0, 0.06)',
                fontFamily: 'serif',
                fontWeight: 'bold',
                color: '#2c3e50',
                fontSize: '0.7rem',
                backdropFilter: 'blur(10px)'
            }}>
                <CopyrightIcon />
                <b>EFFTABS SOLUTIONS LLP</b>
            </div>

            {/* Appointment Creation Modal */}
            {isModalGrpOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    backdropFilter: 'blur(4px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '16px',
                        width: '90%',
                        maxWidth: '600px',
                        maxHeight: '90vh',
                        overflow: 'hidden',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                            padding: '20px',
                            color: 'white',
                            height: '60px',
                        }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <h5 style={{ margin: 0, fontWeight: '700' }}>Create New Appointment</h5>
                                <button
                                    onClick={toggleModalGroup}
                                    style={{
                                        background: 'rgba(255, 255, 255, 0.2)',
                                        border: 'none',
                                        borderRadius: '50%',
                                        width: '36px',
                                        height: '36px',
                                        color: 'white',
                                        fontSize: '24px',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center'
                                    }}
                                >
                                    ×
                                </button>
                            </div>
                        </div>

                        {/* Modal Body */}
                        <form onSubmit={handleAppointmentSubmit} style={{ padding: '24px', maxHeight: 'calc(90vh - 140px)', overflowY: 'auto' }}>
                            <div style={{ display: 'grid', gap: '16px' }}>
                                {/* Patient Selection */}
                                <div>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '6px', color: '#374151' }}>
                                        Patient <span style={{ color: '#dc2626' }}>*</span>
                                    </label>
                                    <input
                                        type="text"
                                        readOnly
                                        placeholder="Click to select patient"
                                        value={appointmentForm.patientName}
                                        onClick={() => setIsPatientModalOpen(true)}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '10px 12px',
                                            border: '2px solid #e5e7eb',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            cursor: 'pointer',
                                            backgroundColor: 'white'
                                        }}
                                    />
                                </div>

                                {/* MRD No */}
                                <div>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '6px', color: '#374151' }}>
                                        MRD No
                                    </label>
                                    <input
                                        type="text"
                                        readOnly
                                        value={appointmentForm.patientMRD}
                                        style={{
                                            width: '100%',
                                            padding: '10px 12px',
                                            border: '2px solid #e5e7eb',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            backgroundColor: '#f9fafb'
                                        }}
                                    />
                                </div>

                                {/* Contact Number */}
                                <div>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '6px', color: '#374151' }}>
                                        Contact Number
                                    </label>
                                    <input
                                        type="text"
                                        readOnly
                                        value={appointmentForm.patientPhone}
                                        style={{
                                            width: '100%',
                                            padding: '10px 12px',
                                            border: '2px solid #e5e7eb',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            backgroundColor: '#f9fafb'
                                        }}
                                    />
                                </div>

                                {/* Doctor Selection */}
                                <div>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '6px', color: '#374151' }}>
                                        Doctor <span style={{ color: '#dc2626' }}>*</span>
                                    </label>
                                    <select
                                        value={appointmentForm.doctorId}
                                        onChange={(e) => handleAppointmentChange('doctorId', e.target.value)}
                                        required
                                        style={{
                                            width: '100%',
                                            padding: '10px 12px',
                                            border: '2px solid #e5e7eb',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                        }}
                                    >
                                        <option value="">Select Doctor</option>
                                        {doctors.map(doctor => (
                                            <option key={doctor.Id} value={doctor.Id}>{doctor.Name}</option>
                                        ))}
                                    </select>
                                </div>

                                {/* Date and Time */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '6px', color: '#374151' }}>
                                            Date <span style={{ color: '#dc2626' }}>*</span>
                                        </label>
                                        <input
                                            type="date"
                                            value={appointmentForm.appointmentDate}
                                            onChange={(e) => handleAppointmentChange('appointmentDate', e.target.value)}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '10px 12px',
                                                border: '2px solid #e5e7eb',
                                                borderRadius: '8px',
                                                fontSize: '14px'
                                            }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '6px', color: '#374151' }}>
                                            Time <span style={{ color: '#dc2626' }}>*</span>
                                        </label>
                                        <input
                                            type="time"
                                            value={appointmentForm.appointmentTime}
                                            onChange={(e) => handleAppointmentChange('appointmentTime', e.target.value)}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '10px 12px',
                                                border: '2px solid #e5e7eb',
                                                borderRadius: '8px',
                                                fontSize: '14px'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Amount */}
                                <div>
                                    <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', marginBottom: '6px', color: '#374151' }}>
                                        Amount
                                    </label>
                                    <input
                                        type="number"
                                        value={appointmentForm.consultationamount || ''}
                                        onChange={(e) => handleAppointmentChange("consultationamount", e.target.value)}
                                        style={{
                                            width: '100%',
                                            padding: '10px 12px',
                                            border: '2px solid #e5e7eb',
                                            borderRadius: '8px',
                                            fontSize: '14px'
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Submit Buttons */}
                            <div style={{ marginTop: '24px', display: 'flex', gap: '12px', justifyContent: 'flex-end' }}>
                                <button
                                    type="button"
                                    onClick={toggleModalGroup}
                                    style={{
                                        padding: '10px 20px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        backgroundColor: 'white'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={isLoading}
                                    style={{
                                        padding: '10px 20px',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                        color: 'white',
                                    }}
                                >
                                    {isLoading ? 'Saving...' : 'Create Appointment'}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}


            {/* Patient Selection Modal */}
            {isPatientModalOpen && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.7)',
                    backdropFilter: 'blur(4px)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 10000
                }}>
                    <div style={{
                        background: 'white',
                        borderRadius: '16px',
                        width: '90%',
                        maxWidth: '700px',
                        maxHeight: '80vh',
                        overflow: 'hidden',
                        boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)',
                            padding: '16px 20px',
                            color: 'white',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}>
                            <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '700' }}>Select Patient</h2>
                            <button
                                onClick={() => setIsPatientModalOpen(false)}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.2)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    color: 'white',
                                    fontSize: '20px',
                                    cursor: 'pointer'
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Search */}
                        <div style={{ padding: '16px' }}>
                            <input
                                type="text"
                                placeholder="Search by name, MRD, or phone..."
                                value={patientSearchQuery}
                                onChange={(e) => setPatientSearchQuery(e.target.value)}
                                style={{
                                    width: '100%',
                                    padding: '10px 12px',
                                    border: '2px solid #e5e7eb',
                                    borderRadius: '8px',
                                    fontSize: '14px',
                                    marginBottom: '12px'
                                }}
                            />

                            {/* Patient List */}
                            <div style={{ maxHeight: 'calc(80vh - 140px)', overflowY: 'auto' }}>
                                {filteredPatients.length > 0 ? (
                                    filteredPatients.map(patient => (
                                        <div
                                            key={patient.Id}
                                            onClick={() => handlePatientSelect(patient)}
                                            style={{
                                                padding: '12px',
                                                border: '1px solid #e5e7eb',
                                                borderRadius: '8px',
                                                marginBottom: '8px',
                                                cursor: 'pointer',
                                                transition: 'all 0.2s',
                                                background: 'white'
                                            }}
                                            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f3f4f6'}
                                            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                                        >
                                            <div style={{ fontWeight: '600', fontSize: '14px', color: '#1f2937', marginBottom: '4px' }}>
                                                {patient.Name}
                                            </div>
                                            <div style={{ fontSize: '12px', color: '#6b7280' }}>
                                                MRD: {patient.MRDNo} | Phone: {patient.ContactNumber1}
                                            </div>
                                        </div>
                                    ))
                                ) : (
                                    <div style={{ textAlign: 'center', padding: '40px', color: '#9ca3af' }}>
                                        No patients found
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Appointment List Modal */}
            {isAppointmentListModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50 p-3" style={{ backgroundColor: 'rgba(0, 0, 0, 0.6)', backdropFilter: 'blur(4px)' }}>
                    <div
                        className="bg-white w-full overflow-hidden"
                        style={{
                            maxWidth: '1200px',
                            maxHeight: '85vh',
                            borderRadius: '16px',
                            boxShadow: '0 20px 40px -12px rgba(0, 0, 0, 0.25)',
                        }}
                    >
                        {/* Modal Header */}
                        <div style={{
                            background: 'linear-gradient(135deg, #059669 0%, #047857 100%)',
                            padding: '16px 24px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            height: '55px',
                        }}>
                            <div>
                                <h6 style={{ color: 'white', fontWeight: '700', margin: 0 }}>
                                    📋 All Appointments
                                </h6>
                                <p style={{ color: 'rgba(255, 255, 255, 0.9)', fontSize: '13px', margin: '4px 0 0 0' }}>
                                    Showing all patient appointments
                                </p>
                            </div>
                            <button
                                onClick={toggleAppointmentListModal}
                                style={{
                                    background: 'rgba(255, 255, 255, 0.2)',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '36px',
                                    height: '36px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    cursor: 'pointer',
                                    color: 'white',
                                    fontSize: '22px',
                                }}
                            >
                                ×
                            </button>
                        </div>

                        {/* Filter Bar */}
                        <div style={{ padding: '16px 20px', borderBottom: '1px solid #e5e7eb', background: '#f9fafb', display: 'flex', gap: '12px', alignItems: 'center' }}>
                            <div style={{ flex: 1 }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#374151', marginBottom: '4px', textTransform: 'uppercase' }}>
                                    📅 Filter by Date
                                </label>
                                <input
                                    type="date"
                                    value={appointmentDateFilter}
                                    onChange={(e) => setAppointmentDateFilter(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '8px 12px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        outline: 'none',
                                    }}
                                />
                            </div>
                            <div style={{ flex: 1 }}>
                                <label style={{ display: 'block', fontSize: '11px', fontWeight: '600', color: '#374151', marginBottom: '4px', textTransform: 'uppercase' }}>
                                    👨‍⚕️ Filter by Doctor
                                </label>
                                <select
                                    value={appointmentDoctorFilter}
                                    onChange={(e) => setAppointmentDoctorFilter(e.target.value)}
                                    style={{
                                        width: '100%',
                                        padding: '8px 12px',
                                        border: '2px solid #e5e7eb',
                                        borderRadius: '8px',
                                        fontSize: '13px',
                                        outline: 'none',
                                        backgroundColor: 'white',
                                    }}
                                >
                                    <option value="">All Doctors</option>
                                    {[...new Set(appointmentsList.map(apt => apt.DoctorName).filter(Boolean))].sort().map((doctorName, index) => (
                                        <option key={index} value={doctorName}>{doctorName}</option>
                                    ))}
                                </select>
                            </div>
                            {(appointmentDateFilter || appointmentDoctorFilter) && (
                                <button
                                    onClick={() => {
                                        setAppointmentDateFilter('');
                                        setAppointmentDoctorFilter('');
                                    }}
                                    style={{
                                        padding: '8px 16px',
                                        background: '#ef4444',
                                        color: 'white',
                                        border: 'none',
                                        borderRadius: '8px',
                                        fontSize: '12px',
                                        fontWeight: '600',
                                        cursor: 'pointer',
                                        marginTop: '20px',
                                    }}
                                >
                                    ✕ Clear
                                </button>
                            )}
                        </div>

                        {/* Modal Body */}
                        <div className="overflow-y-auto" style={{ maxHeight: 'calc(85vh - 160px)', padding: '0' }}>
                            {isLoadingAppointments ? (
                                <div style={{ padding: '40px', textAlign: 'center' }}>
                                    <CircularProgress size={40} style={{ color: '#059669' }} />
                                    <p style={{ marginTop: '16px', color: '#6b7280' }}>Loading appointments...</p>
                                </div>
                            ) : getFilteredAppointments().length === 0 ? (
                                <div style={{ padding: '40px', textAlign: 'center', color: '#6b7280' }}>
                                    <p style={{ fontSize: '16px', fontWeight: '500' }}>
                                        {(appointmentDateFilter || appointmentDoctorFilter) ? 'No appointments match your filters' : 'No appointments found'}
                                    </p>
                                </div>
                            ) : (
                                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                                    <thead style={{ position: 'sticky', top: 0, zIndex: 10 }}>
                                        <tr>
                                            {['#', 'Date', 'Time', 'Patient Name', 'MRD No', 'Doctor', 'Amount', 'Status'].map((header, idx) => (
                                                <th key={idx} style={{
                                                    background: 'linear-gradient(180deg, #059669 0%, #047857 100%)',
                                                    color: 'white',
                                                    padding: '10px',
                                                    fontSize: '11px',
                                                    fontWeight: '700',
                                                    textAlign: header === 'Amount' ? 'right' : 'left',
                                                    textTransform: 'uppercase',
                                                    borderRight: '1px solid rgba(255,255,255,0.1)'
                                                }}>
                                                    {header}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {getFilteredAppointments().map((appointment, index) => (
                                            <tr
                                                key={appointment.Id}
                                                style={{
                                                    backgroundColor: index % 2 === 0 ? 'white' : '#f9fafb',
                                                    transition: 'background-color 0.15s ease'
                                                }}
                                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0fdf4'}
                                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? 'white' : '#f9fafb'}
                                            >
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#059669', fontWeight: '600', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>
                                                    {index + 1}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '500', borderBottom: '1px solid #e5e7eb' }}>
                                                    {formatDate(appointment.AppointmentDate)}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '500', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.AppointmentTime || 'N/A'}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '600', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.PatientName || 'N/A'}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '500', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.MRDNo || 'N/A'}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '600', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.DoctorName || 'N/A'}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '12px', color: '#1f2937', fontWeight: '600', textAlign: 'right', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.Amount || '0'}
                                                </td>
                                                <td style={{ padding: '12px', fontSize: '11px', textAlign: 'center', borderBottom: '1px solid #e5e7eb' }}>
                                                    {appointment.IsCompleted ? (
                                                        <span style={{ background: '#d1fae5', color: '#065f46', padding: '4px 12px', borderRadius: '12px', fontWeight: '600' }}>
                                                            ✓ Completed
                                                        </span>
                                                    ) : appointment.IsRescheduled ? (
                                                        <span style={{ background: '#fef3c7', color: '#92400e', padding: '4px 12px', borderRadius: '12px', fontWeight: '600' }}>
                                                            ↻ Rescheduled
                                                        </span>
                                                    ) : (
                                                        <span style={{ background: '#dbeafe', color: '#1e40af', padding: '4px 12px', borderRadius: '12px', fontWeight: '600' }}>
                                                            ⏳ Pending
                                                        </span>
                                                    )}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}

export default AppointmentIndex; 